// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import './assets/dist/css/style.css'

Vue.config.productionTip = false;

// A result link's document id + token must never leave the browser via
// Sentry. Strip the token path segment and any bare 64-char hex string
// (the token shape) from anything Sentry would otherwise capture.
const RESULT_TOKEN_PATTERN = /\/results\/([^/?#]+)\/([0-9a-f]{64})/gi;
const BARE_TOKEN_PATTERN = /\b[0-9a-f]{64}\b/gi;

function scrubResultLinks(value) {
  if (typeof value !== 'string') {
    return value;
  }
  return value
    .replace(RESULT_TOKEN_PATTERN, '/results/$1/[redacted]')
    .replace(BARE_TOKEN_PATTERN, '[redacted]');
}

function scrubEvent(value) {
  if (typeof value === 'string') {
    return scrubResultLinks(value);
  }
  if (Array.isArray(value)) {
    return value.map(scrubEvent);
  }
  if (value && typeof value === 'object') {
    Object.keys(value).forEach((key) => {
      value[key] = scrubEvent(value[key]);
    });
  }
  return value;
}

Sentry.init({
  Vue,
  dsn: "https://79e0ccf572de4cbbabb0b19a95140ad1@o243225.ingest.sentry.io/6618216",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost", "acc-www.testjewerkgeluk.nl", "www.testjewerkgeluk.nl", /^\//],
    }),
  ],
  tracesSampleRate: 1.0,
  beforeSend: scrubEvent,
  beforeSendTransaction: scrubEvent,
  beforeBreadcrumb: (breadcrumb) => {
    if (breadcrumb.data && breadcrumb.data.url) {
      breadcrumb.data.url = scrubResultLinks(breadcrumb.data.url);
    }
    if (breadcrumb.data && breadcrumb.data.to) {
      breadcrumb.data.to = scrubResultLinks(breadcrumb.data.to);
    }
    if (breadcrumb.data && breadcrumb.data.from) {
      breadcrumb.data.from = scrubResultLinks(breadcrumb.data.from);
    }
    if (breadcrumb.message) {
      breadcrumb.message = scrubResultLinks(breadcrumb.message);
    }
    return breadcrumb;
  },
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  logErrors: true,
  template: '<App/>',
  components: {App}
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js